import config from '@/config'

export default {
  login: "เข้าสู่ระบบบัญชีของคุณ",
  relogin: "กรุณาเข้าสู่ระบบบัญชีของคุณอีกครั้ง",
  expired: "เซสชันหมดอายุ!",
  denied: "การเข้าถึงถูกปฏิเสธ!",
  success: "สำเร็จ",
  search_by_id: "ค้นหาตาม ID",
  successful_change_password: "คุณได้เปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
  select_option: "เลือกตัวเลือกของคุณ",
  no_data_available: "ไม่มีข้อมูลที่พร้อมใช้งาน",
  no_rating_available: "ไม่มีการให้คะแนนที่พร้อมใช้งาน",
  successful_update_security: "คุณได้อัปเดตความปลอดภัยเรียบร้อยแล้ว",
  successful_disable_security: "คุณได้ปิดการใช้งานความปลอดภัยเรียบร้อยแล้ว",
  update_security_confirm: "คุณแน่ใจหรือไม่ว่าต้องการอัปเดตความปลอดภัย?",
  disable_security_confirm: "คุณแน่ใจหรือไม่ว่าต้องการปิดการใช้งานความปลอดภัย?",
  change_operator_status_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะของผู้ดำเนินการ \"{name}\"?",
  change_member_status_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะของสมาชิก \"{name}\"?",
  change_bank_account_status_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะบัญชี \"{name}\"?",
  change_promotion_seq_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนลำดับ \"{id}\"?",
  change_promo_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะการโปรโมตของ \"{name}\"?",
  change_promo_signup_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะการลงทะเบียนโปรโมตของ \"{name}\"?คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะการโปรโมตของ \"{name}\"?",
  successful_update_account_setup: "คุณได้อัปเดตการตั้งค่าบัญชีเรียบร้อยแล้ว",
  unblock_member_confirm: "“คุณแน่ใจหรือว่าต้องการปลดบล็อกสมาชิก \"{name}\"?",
  unblock_operator_confirm: "”คุณแน่ใจหรือว่าคุณต้องการปลดบล็อกผู้ดูแลระบบ \"{name}\"?",
  block_sub_account_confirm: "คุณแน่ใจหรือว่าต้องการบล็อกบัญชีย่อย \"{name}\"?",
  unblock_sub_account_confirm: "คุณแน่ใจหรือว่าต้องการปลดบล็อกบัญชีย่อย \"{name}\"?",
  successful_update_account_password: "คุณได้อัปเดตรหัสผ่านบัญชีเรียบร้อยแล้ว",
  change_affiliate_status_confirm: "”คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะของพันธมิตร \"{name}\"?",
  unblock_affiliate_confirm: "คุณแน่ใจหรือว่าต้องการปลดบล็อกพันธมิตร \"{name}\"?",
  change_coupon_status_confirm: "“คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะคูปองของ \"{name}\"，",
  submit_acknowledgement_confirm: "คุณแน่ใจหรือว่าต้องการส่งการยืนยัน?",
  change_bank_group_default_confirm: "“คุณแน่ใจหรือว่าต้องการตั้ง \"{name}\" เป็นกลุ่มธนาคารเริ่มต้น?",
  change_withdrawal_limit_default_confirm: "”คุณแน่ใจหรือว่าต้องการตั้ง \"{name}\" เป็นขีดจำกัดการถอนเงินเริ่มต้น?",
  change_promotion_group_default_confirm: "คุณแน่ใจหรือว่าต้องการตั้ง \"{name}\" เป็นกลุ่มโปรโมชั่นเริ่มต้น?",
  change_withdrawal_limit_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนขีดจำกัดการถอนของ \"{name}\"?",
  change_promotion_group_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนกลุ่มโปรโมชั่นของ \"{name}\"?",
  change_bank_group_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนกลุ่มธนาคารของ \"{name}\"?",
  change_member_bet_limit_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนขีดจำกัดการเดิมพัน \"{name}\" \"{provider}\"?",
  assign_free_credit_confirm: "คุณแน่ใจหรือว่าต้องการมอบเครดิตฟรีให้กับ \"{name}\"?",
  update_survey_status_confirm: "คุณแน่ใจหรือว่าต้องการอัปเดตสถานะการสำรวจ?",
  move_banner_up_confirm: "คุณแน่ใจหรือว่าต้องการเลื่อนแบนเนอร์ \"{name}\" ขึ้น?",
  move_banner_down_confirm: "คุณแน่ใจหรือว่าต้องการเลื่อนแบนเนอร์ \"{name}\" ลง?",
  delete_banner_confirm: "คุณแน่ใจหรือว่าต้องการลบแบนเนอร์ \"{name}\"?",
  change_banner_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะแบนเนอร์ \"{name}\"?",
  delete_page_confirm: "คุณแน่ใจหรือว่าต้องการลบหน้า \"{name}\"?",
  change_page_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะหน้าของ \"{name}\"?",
  clear_maintenance_time_confirm: "คุณแน่ใจหรือว่าต้องการล้างเวลาบำรุงรักษาของ \"{name}\"?",
  successful_clear_outstanding: "คุณได้ลบจำนวนเงินคงค้าง {amt} สำเร็จแล้ว",
  clear_outstanding_confirm: "คุณแน่ใจหรือว่าต้องการลบยอดค้างของ \"{name}\"?",
  trace_outstanding_confirm: "คุณแน่ใจหรือว่าต้องการติดตามยอดค้างของ \"{name}\"?",
  delete_ip_address_confirm: "คุณแน่ใจหรือว่าต้องการลบ ip \"{ip}\" ภายใต้ \"{name}\"?",
  change_payment_mode_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะโหมดการชำระเงินของ \"{name}\"?",
  redeposit_ticket_confirm: "คุณแน่ใจหรือว่าต้องการฝากตั๋วใหม่?",
  audit_ticket_confirm: "คุณแน่ใจหรือว่าต้องการตรวจสอบตั๋วนี้?",
  review_ticket_confirm: "คุณแน่ใจหรือว่าต้องการตรวจสอบตั๋วนี้?",
  change_promotion_group_seq_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนลำดับ \"{promotion}\" ภายใต้ \"{group}\"?",
  move_affiliate_confirm: "คุณแน่ใจหรือว่าต้องการย้ายสาขาทั้งหมดของ \"{name}\" ไปอยู่ภายใต้ \"{operator}\" โดยตรง?",
  cancel_unfinish_round_confirm: "คุณแน่ใจหรือว่าต้องการยกเลิกการหมุนรอบที่ยังไม่เสร็จ \"{round}\"?",
  change_payment_mode_seq_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนลำดับ \"{mode}\"?",
  change_label_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะป้ายชื่อ \"{name}\"?",
  clear_iframe_url_confirm: "คุณแน่ใจหรือว่าต้องการลบ URL ของ iframe?，",
  delete_turnover_tier_confirm: "คุณแน่ใจหรือว่าต้องการลบระดับการหมุนเวียน \"{name}\"?",
  vip_provider_rebate_batch_confirm: "คุณยืนยันที่จะดำเนินการอัปเดตส่วนลดสำหรับผู้ให้บริการ VIP หรือไม่?",
  copy_rebate_rate_all_confirm: "คุณแน่ใจหรือว่าต้องการคัดลอก \"{name}\" ของ \"{provider}\" ",
  edit_vip_confirm: "คุณต้องการอัปเดตราคาเงินคืนของ \"{name}\" หรือไม่?",
  add_promotion_custom_member_confirm: "คุณต้องการเพิ่มรายการสมาชิกโปรโมชั่นแบบกำหนดเองหรือไม่?",
  delete_promotion_custom_member_confirm: "คุณต้องการลบรายการสมาชิกโปรโมชั่นที่กำหนดเองของ \"{name}\" หรือไม่?",
  change_rescue_fund_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะกองทุนช่วยเหลือ \"{name}\"?",
  add_rescue_fund_custom_member_confirm: "คุณต้องการเพิ่มรายชื่อสมาชิกที่กำหนดเองสำหรับกองทุนช่วยเหลือหรือไม่?",
  delete_rescue_fund_custom_member_confirm: "”คุณต้องการลบรายชื่อสมาชิกที่กำหนดเองของกองทุนช่วยเหลือ \"{name}\" หรือไม่?",
  change_ads_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะโฆษณาของ \"{name}\"?",
  adjust_amount_bank_tooltip: "รองรับเครื่องหมายลบ (-) เพื่อลดยอดเงินจากยอดเงินในบัญชีธนาคาร",
  adjust_amount_operator_tooltip: "รองรับเครื่องหมายลบ (-) เพื่อลดยอดเงินจากกระเป๋าเงินของผู้ให้บริการ",
  adjust_amount_member_tooltip: "รองรับเครื่องหมายลบ (-) เพื่อลดยอดเงินจากยอดเงินของสมาชิก",
  change_provider_game_seq_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนลำดับ \"{mode}\"?",
  purchase_domain_confirm: "คุณแน่ใจที่จะซื้อโดเมน \"{name}\" หรือไม่?",
  search_by_domain_name: "ค้นหาตามชื่อโดเมน",
  search_by_domain_status: "ค้นหาตามสถานะโดเมน",
  search_by_account_id: "ค้นหาตามรหัสบัญชี",
  search_by_operator_id: "ค้นหาตาม Operator ID",
  search_by_full_name: "ค้นหาตามชื่อเต็ม",
  search_by_contact_phone: "ค้นหาตามหมายเลขโทรศัพท์ติดต่อ",
  search_by_signup_ip: "ค้นหาตาม IP ที่ลงทะเบียน",
  search_by_referral_code: "ค้นหาตามรหัสแนะนำ",
  search_by_bank_acc_no: "ค้นหาตามหมายเลขบัญชีธนาคาร",
  search_by_affiliate_code: "ค้นหาตามรหัสพันธมิตร",
  info1: "1. ไม่อนุญาตให้ใช้ซับโดเมน",
  info2: "2. ไม่ต้องการ 'https://' หรือ 'http://'",
  info3: "3. ตัวอย่าง: abc.com",
  move_announcement_banner: "เรียงลำดับแบนเนอร์ใหม่",
  atLeastOneChecked: "ต้องตรวจสอบอย่างน้อยหนึ่งเกณฑ์",
  adjustWalletTooltips: "สนับสนุนเครื่องหมายลบ (-) เพื่อลดยอดเงินในกระเป๋าเงินของพันธมิตร",
  domain_status_update_confirm: "คุณต้องการอัปเดตสถานะของ \"{name}\" หรือไม่?",
  move_banner_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยน \"{name}\" เป็นตำแหน่ง \"{position}\"?",
  delete_game_exclude_confirm: "คุณแน่ใจหรือว่าต้องการลบ \"{name}\"?",
  banner_size_tooltips: "กรุณาปฏิบัติตามขนาดภาพที่อนุญาต: \"{size}\".",
  purchase_domain_success: "ซื้อโดเมนสำเร็จแล้ว!",
  apply_domain_success: "สมัครโดเมนสำเร็จแล้ว!",
  search_by_lang_code: "ค้นหาตามรหัสภาษา",
  pleaseSelectAnImage: "กรุณาเลือกภาพ",
  pleaseSelectAValidImageType: "กรุณาเลือกประเภทภาพที่ถูกต้อง",
  imageTooLargeMaxSizeAllowedIsOneMb: "ขนาดภาพใหญ่เกินไป ขนาดสูงสุดที่อนุญาตคือ 1MB",
  uploadYourLogoWithPngOrJpegFormat: "อัปโหลดโลโก้ของคุณในรูปแบบ png หรือ jpeg",
  allowedPngAndJpegOnlyMaxOneMb: "อนุญาตเฉพาะ png และ jpeg เท่านั้น (ขนาดภาพสูงสุด 1MB)",
  delete_theme_content_confirm: "คุณแน่ใจหรือว่าต้องการลบเนื้อหาธีม \"{themecontent}\"?",
  delete_theme_confirm: "คุณแน่ใจหรือว่าต้องการลบธีม \"{theme}\"?",
  delete_color_confirm: "คุณแน่ใจหรือว่าต้องการลบสี \"{color}\"?",
  delete_content_confirm: "คุณแน่ใจหรือว่าต้องการลบเนื้อหา \"{content}\"?",
  needAiToGenerateLogo: "ต้องการ AI เพื่อสร้างโลโก้",
  previewImageForIllustrationOnly: "ภาพตัวอย่างที่แสดงไว้เป็นเพียงเพื่อการอ ilustration เท่านั้น",
  actualResultMayVary: "ผลลัพธ์จริงอาจแตกต่างออกไปเนื่องจากการปรับปรุงเว็บไซต์",
  delete_theme_content_group_confirm: "คุณแน่ใจหรือว่าต้องการลบกลุ่มเนื้อหาธีม \"{themecontentgroup}\"?",
  change_theme_will_replace_menu: "คุณแน่ใจหรือว่าต้องการอัปเดตธีม? (การเปลี่ยนธีมจะทำให้เมนูถูกแทนที่)",
  change_provider_seq_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนลำดับของ \"{provider}\"?",
  change_provider_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะของผู้ให้บริการ \"{provider}\"?",
  actionPerformWillReflectProd: "* การดำเนินการใด ๆ ที่ทำที่นี่จะสะท้อนโดยตรงไปยัง Production",
  site_sync_confirm: "คุณแน่ใจหรือว่าต้องการซิงค์ไปยัง Production?",
  clear_profile_setting_maintenance_confirm: "คุณแน่ใจหรือว่าต้องการล้างการบำรุงรักษา?",
  change_social_platform_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะแพลตฟอร์มโซเชียลของ \"{name}\"?",
  search_by_site_name: "ค้นหาตาม Site Name",
  change_social_account_status_confirm: "คุณแน่ใจหรือว่าต้องการเปลี่ยนสถานะบัญชีโซเชียลของ \"{name}\"?สถานะบัญชีโซเชียลของ \"{name}\"?",
  themeMenuMessage1: "* จัดเรียงลำดับเมนูใหม่โดยการลากและวางรายการเมนู",
  themeMenuMessage2: "* ยกเลิกการเลือกช่องทำเครื่องหมายหากต้องการซ่อนรายการเมนู",
  search_by_operator: "ค้นหาตามผู้ดูแลระบบ",
  search_by_ticket: "ค้นหาตามตั๋ว",
  search_member: "ค้นหาสมาชิก",
  search_by_game_type: "ค้นหาตามประเภทเกม",
  tooltips_upload_size: "ขนาดไฟล์ที่อัปโหลดไม่สามารถเกิน 1MB ได้",
  tooltips_href: "ฟิลด์ Href ต้องการการขยายโดเมน เช่น: 'yourwebsite.com/promotions', กรอก 'promotions' ก็เพียงพอ",
  d_winlose_chart: "แสดงแนวโน้มการชนะ/แพ้ และการถอนเงิน",
  d_turnover_chart: "วิเคราะห์แนวโน้มการหมุนเวียนและการฝากเงิน",
  d_deposit: "แสดงจำนวนการฝากและสมาชิกที่ไม่ซ้ำกัน",
  d_withdrawal: "แสดงจำนวนธุรกรรมการถอนทั้งหมด",
  d_active_player: "จำนวนการเดิมพันและการเข้าสู่ระบบที่ไม่ซ้ำกันโดยผู้เล่น",
  d_winlose: "แสดงยอดชนะ/แพ้สุทธิ",
  d_turnover: "ยอดการหมุนเวียนทั้งหมดที่สร้างขึ้น",
  d_member: "จำนวนสมาชิกที่ลงทะเบียนทั้งหมด",
  d_referee: "จำนวนการแนะนำผู้ใช้ทั้งหมด",
  d_verfied_signup: "จำนวนผู้ใช้ที่ได้รับการตรวจสอบและการลงทะเบียนใหม่",
  d_ftd: "จำนวนและจำนวนเงินฝากครั้งแรก",
  d_top_winner: "รหัสผู้เล่นและยอดชนะรวม",
  d_top_loser: "รหัสผู้เล่นและยอดแพ้รวม",
  d_top_deposit: "รหัสผู้เล่นและยอดเงินฝากรวมจากมากไปน้อย",
  d_top_withdrawal: "รหัสผู้เล่นและยอดการถอนรวมจากมากไปน้อย",
  d_top_promotion: "อันดับ, รหัสโปรโมชั่น, ชื่อ, และการเรียกร้องของผู้เล่น",
  d_payment_gateway: "อันดับ, วิธีการ, ผู้ขาย, การประมวลผล, การปฏิเสธ, ยอดรวม, และอัตราความสำเร็จผ่านเกตเวย์โปรดใส่รหัสสมาชิกหลายรหัสโดยใช้เครื่องหมายจุลภาคเป็นตัวแบ่ง",
  tooltips_promo_member_custom: "กรุณาใส่รหัสสมาชิกหลาย ๆ รหัสโดยใช้เครื่องหมายจุลภาคเป็นตัวแบ่ง ตัวอย่าง: member001,member002,member003",
  tooltips_social_facebook: "ตัวอย่าง: https://www.facebook.com/",
  tooltips_social_instagram: "ตัวอย่าง: https://www.instagram.com/",
  tooltips_social_skype: "ตัวอย่าง: skype:<username>?chat",
  tooltips_social_telegram: "ตัวอย่าง: https://t.me/<ID>",
  tooltips_social_tiktok: "ตัวอย่าง: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "ตัวอย่าง: <ID>",
  tooltips_social_whatsapp: "ตัวอย่าง: https://wa.me/<ID>",
  tooltips_social_youtube: "ตัวอย่าง: https://www.youtube.com/<ID>",
  search_by_business_id: "ค้นหาตามรหัสธุรกิจ",
  ticket_taken_confirm: "คุณแน่ใจหรือว่าต้องการควบคุมรหัสตั๋วนี้ \"{name}\"?",
  tooltips_payment_setting: "ด้านล่างนี้จะถูกสะท้อนเฉพาะเมื่อ 'การตั้งค่า' - 'การตั้งค่าการชำระเงิน' ถูกตั้งค่าเป็น 'ของฉัน'",
  tooltips_cms_announcement_main: "สูงสุด 5 แบนเนอร์ประกาศเพื่อประสบการณ์ผู้ใช้ที่ดีที่สุด",
  tooltips_cms_announcement_title: "สูงสุด 30 ตัวอักษรเพื่อประสบการณ์ผู้ใช้ที่ดีที่สุด",
  tooltips_cms_announcement_body: "สูงสุด 200 ตัวอักษรเพื่อประสบการณ์ผู้ใช้ที่ดีที่สุด",
  delete_livechat_confirm: "คุณแน่ใจหรือว่าต้องการลบแชทสด?",
  tooltips_vip_name: "สูงสุด 10 ตัวอักษรเพื่อประสบการณ์ผู้ใช้ที่ดีที่สุด",
  tooltips_sequence: "ตัวเลขลำดับยิ่งน้อย ความสำคัญของเกมจะยิ่งสูงขึ้น",
  tooltips_turnover: "ยอดเทิร์นโอเวอร์ของสมาชิก",
  tooltips_rebate_rate: "อัตรารีเบตของสมาชิก (%)",
  tooltips_promo_bonus_rate: "แนะนำให้ตั้งไว้ที่ 100% ส่วนที่เกินจาก 100% จะเป็นความรับผิดชอบของผู้ให้บริการ",
  tooltips_promo_signup: "แนะนำให้ตั้งไว้ระหว่าง AUD1 ถึง AUD20 ส่วนที่เกินจากช่วงนี้จะเป็นความรับผิดชอบของผู้ให้บริการ",
  tooltips_bonus_issue: "แนะนำให้ตั้งไว้ระหว่าง AUD1 ถึง AUD1000 ส่วนที่เกินจากช่วงนี้จะเป็นความรับผิดชอบของผู้ให้บริการ",
  tooltips_vip_cycle_day: "รอบระยะเวลา VIP จะถูกนับเป็นวัน",
  vip_info1: "ระดับ VIP เมื่อตั้งค่าแล้วสามารถแก้ไขได้เท่านั้น ไม่สามารถลบได้",
  website_launched: "แสดงจำนวนเว็บไซต์ที่เปิดใช้งานทั้งหมด เว็บไซต์รวมถึงวันนี้ ผู้ให้บริการทั้งหมด และเว็บไซต์ที่ใช้งานในวันนี้",
  new_player_verified_signup: "แสดงจำนวนผู้เล่นใหม่ ผู้เล่นที่ใช้งานทั้งหมด และผู้เล่นทั้งหมดจนถึงวันที่ที่เลือก",
  depo_withdrawal_diff: "แสดงความแตกต่างระหว่างยอดฝากและยอดถอน รายละเอียดการฝาก และรายละเอียดการถอน",
  bonus: "แสดงจำนวนโบนัสทั้งหมดที่เคลมและจำนวนการเคลมที่สำเร็จ",
  ggr: "แสดงรายได้รวมจากการเล่น (GGR) และยอดเงินคงเหลือของสมาชิก ณ วันที่เลือก",
  turnover: "แสดงยอดเทิร์นโอเวอร์รวมและเปอร์เซ็นต์ RTP ปัจจุบันจนถึงวันที่ที่เลือก",
  provider_pt_on_global_confirm: "คุณแน่ใจหรือไม่ว่าต้องการอัปเดตเกณฑ์ของผู้ให้บริการ \"{name}\" PT?",
  approve_affiliate_ticket_confirm: "คุณแน่ใจหรือไม่ว่าต้องการอนุมัติบัตรคำขอพันธมิตรนี้?",
  change_payment_option_recommend_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนคำแนะนำ \"{group}\" ภายใต้ \"{mode}\"?",
  pleaseFillUpSiteDetails: "กรุณากรอกรายละเอียดเว็บไซต์ของคุณ",
  chooseYourPreferedResponsiveLayoutTheme: "เลือกธีมการจัดวางที่ตอบสนองที่คุณต้องการ",
  chooseYourPreferedColor: "เลือกสีที่คุณต้องการ",
  pleaseSelectTheme: "กรุณาเลือกธีม",
  pleaseSelectColor: "กรุณาเลือกสี",
  websiteLayoutAndThemeDesign: "การออกแบบเลย์เอาต์และธีมเว็บไซต์",
  operatorAccCreatedSuccessful: "สร้างบัญชีผู้ดูแลระบบเรียบร้อยแล้ว",
  search_by_template_code: "ค้นหาตามรหัสแม่แบบ",
  delete_mini_game_confirm: "คุณแน่ใจหรือไม่ว่าต้องการลบมินิเกม \"{minigame}\"?",
  delete_mini_game_template_confirm: "คุณแน่ใจหรือไม่ว่าต้องการลบแม่แบบมินิเกม \"{minigametemplate}\"?",
  search_by_game_name: "ค้นหาตามชื่อเกม",
  tooltips_gamereward: "ขีดจำกัด: {max}",
  change_gamify_status_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะรางวัลของ \"{gamify}\"?",
  change_gamify_daily_login_status_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะรางวัลของการเช็กอินรายวัน (เข้าสู่ระบบรายวัน)?",
  change_partner_seq_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนลำดับ \"{id}\"?",
  tooltips_partners_link: "ตัวอย่าง: https://www.google.com/",
  delete_partner_confirm: "คุณแน่ใจหรือไม่ว่าต้องการลบพาร์ทเนอร์ \"{name}\"?",
  change_account_chat_status_confirm: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะแชทสด?",
  uploadYourManifestWithPngJpegFormat: "อัปโหลดรายการของคุณในรูปแบบ png หรือ jpeg",
  whitelist_ip_tooltips: "กรุณาแจ้งผู้ให้บริการเพื่อเพิ่ม IP: \"{ip}\" เข้าในบัญชีที่อนุญาต",
  tooltips_inpay_api_url: "ตัวอย่าง: https://www.google.com/",
  info_app_link: "ตัวอย่าง: https://www.google.com/"
};